import users from "./users";
import company from "./company";
import { combineReducers } from "redux";

export default combineReducers({
  company,
  users,
});
